import styled from '@emotion/styled';
import { Skeleton } from '@ferreri/prever-component-lib';

const SkeletonWithoutShrink = styled(Skeleton)`
  flex-shrink: 0;
`;

export const SkeletonCardPlanVersion = () => {
  return <SkeletonWithoutShrink width="100%" maxWidth={282} height={1169} />;
};
